import { h } from 'preact';

let newlineRegex = /(\r\n|\r|\n)/g;

export default function (str) {
  if (typeof str === 'number') {
    return str;
  } else if (typeof str !== 'string') {
    return '';
  }

  return str.split(newlineRegex).map(function(line, index) {
    if (line.match(newlineRegex)) {
      return <br />;
    }
    return line;
  });
};


// WEBPACK FOOTER //
// ./ts/nl2br.tsx